<template>
    <div class="Classification">
        <div class="left">
            <el-tree
                :data="Treedata"
                node-key="id"
                :props="defaultProps"
                default-expand-all
                :highlight-current="highlight"
                draggable
                :allow-drop="allowDrop"
                @node-drop="sort"
                :expand-on-click-node="false"
                @node-click="handleNodeClick">
                <span class="custom-tree-node" slot-scope="{ node, data }" @mouseover="mouseover(data)" @mouseleave="mouseleave(data)">
                    <span>{{ data.categoryName }}</span>
                    <span>
                        <i class="el-icon-plus" v-show="data.plus" @click="() => append(data)"></i>
                        <i class="el-icon-minus" v-show="data.minus"  @click="() => remove(node, data)"></i>
                        <i class="el-icon-edit" v-show="data.edit"  @click="() => editSublevel(data, node)"></i>
                    </span>
                </span>
            </el-tree>
        </div>
        <el-dialog
            :title="isEdit ? '编辑层级' : '创建层级'"
            :visible.sync="sublevelVisible"
            :append-to-body="true"
            width="40%">
            <el-form ref="ruleForm" :model="sublevelForm" :rules="sublevelRules" label-width="120px">
                <el-form-item
                label="名称"
                prop="categoryName"
                >
                    <el-input
                        v-model="sublevelForm.categoryName"
                        autocomplete="off"
                        placeholder="请输入名称"
                        style="width:60%"
                    ></el-input>
                </el-form-item>
                <el-form-item label="父级">
                    <el-input
                        v-model="sublevelForm.parentName"
                        disabled
                        style="width:60%"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="sublevelVisible = false">取 消</el-button>
                <el-button type="primary" @click="sublevelSubmit('ruleForm')">确 定</el-button>
            </div>
        </el-dialog>
        <div class="right">
			<!-- 符合查询条件的产品共-->
			<div class="summary_pagenum">
				<div class="summary_query">
                    <el-button type="primary" @click="edit('all')">批量移动分类</el-button>
				</div>
                <div class="block">
                    <el-checkbox v-model="isNullCategory" style="margin-right:20px">无分类选项</el-checkbox>
                    <el-input v-model="search" placeholder=""></el-input>
                    <el-button type="primary" @click="Search">搜索</el-button>
                    <el-button type="primary" @click="searchReset">重置</el-button>
                </div>
			</div>
			<div class="summary_content">
				<div class="summary_list">
					<!-- 头部 -->
					<el-table
						:data="summarylist"
						style="width: 100%"
						element-loading-text="拼命加载中"
						border
						:header-cell-style="iscenter"
                        @selection-change="on_batch_select"
						stripe
					>
						<el-table-column
							width="50"
							type="selection"
							align="center"
						></el-table-column>
						<el-table-column
                            prop="productCode"
							label="商品编号"
							align="center"
						>
						</el-table-column>
						<el-table-column
                            width="120" 
                            prop="title"
                            label="商品图片"
                        >
                            <template slot-scope="scope">
                                <el-image
                                    style="width: 100px; height: 100px"
                                    :src="scope.row.productImage"
                                    fit="fill"
                                    :preview-src-list="scope.row.productImages"></el-image>
                            </template>
						</el-table-column>
						<el-table-column
							label="商品信息"
							align="center"
						>
                            <template slot-scope="scope">
                                <div v-if="scope.row.title">商品名称：{{ scope.row.title }}</div>
                                <div v-if="scope.row.productCode">商品主SKU：{{ scope.row.productCode }}</div>
                                <div v-for="(item,index) in scope.row.relatedItems" :key="index">
                                    <div v-for="(key,index) in item.aliasItems" :key="index">
                                        <p v-if="key.productCodeAlias">商品SKU别名：{{ key.productCodeAlias }}</p>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
						<el-table-column
							label="商品状态"
							align="center"
						>
                            <template slot-scope="scope">
                                <p v-if="scope.row.status == 1" style="color: green">在售</p>
                                <p v-else-if="scope.row.status == 2" style="color: red">停售</p>
                                <p v-else-if="scope.row.status == 3" style="color: #0f59a4;">试卖</p>
                                <p v-else-if="scope.row.status == 4" style="color: orange">部分停售</p>
                                <p v-else-if="scope.row.status == 5">清仓</p>
                                <p v-else>部分清仓</p>
                            </template>
                        </el-table-column>
						<el-table-column
							prop="creater"
							label="创建人"
							align="center"
						>
						</el-table-column>
						<el-table-column
							prop="createTime"
							label="创建时间"
							align="center"
						>
						</el-table-column>
						<el-table-column
							label="操作"
							fixed="right"
							:width="operateWidth"
							align="center"
						>
							<template slot-scope="scope">
                                <div>
                                    <el-button type="text" style="border:none" @click="edit('single', scope.row)">移动分类</el-button>
                                </div>
							</template>
						</el-table-column>
					</el-table>
				</div>
            </div>
			<div class="summary_pagenum_block">
				<div class="block">
					<el-pagination
						@current-change="handleCurrentChange"
						:current-page="currentPage"
						@size-change="handleSizeChange"
                        :page-size="size"
						:page-sizes="[10, 20, 50, 100]"
						layout="total, sizes, prev, pager, next, jumper"
						:total="count"
					></el-pagination>
				</div>
			</div>
        </div>
        <el-dialog
            title="移动分类"
            :visible.sync="dialogVisible"
            width="width">
            <div>
                <div class="selectNodeValue">
                    {{ selectNodeValue }}
                </div>
                <!-- <el-input
                    class="margin-bottom-20"
                    v-model="productKeyword"
                    placeholder="输入产品关键字"
                ></el-input> -->
                <el-cascader-panel
                    class="custom-cascader"
                    :options="Treedata"
                    :props="props"
                    emitPath="true"
                    @expand-change="cascaderChange"
                    @change="cascaderChange($event, true)"
                >
                    <!-- <template slot-scope="{ data }">
                        <span>{{ data.categoryName }}</span>
                    </template> -->
                </el-cascader-panel>
            </div>
            <div slot="footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" :disabled="!isLastChildNode" @click="submitOuterForm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
let id = 1000;
import { ajaxGet, ajaxPost, Baseurl } from '../../api/api/api'
export default {
    name: 'Classification',
    data() {
        return {
            highlight: true,
            piece: 0,
            categoryId: '',
            batch_select: [],
            batch_select2: [],
            isLastChildNode: false,
            isNullCategory: false,
            isEdit: false,
            sublevelVisible: false,
			currentPage: 1,
			size: 10,
			count: 1,
            str: '',
            companyId: '',
            Treedata: [],
            dialogVisible: false,
            selectNodeValue: '',
            search: '',
            summarylist: [],
			operateWidth: 100,
			iscenter: {
				textAlign: 'center',
				background: '#f8f8f8',
				color: '#232323',
			},
            defaultProps: {
                children: "children",
                label: "categoryName"
            },
            sublevelForm: {
                categoryName: "",
                parentName: "",
                id: "",
                parentId: ""
            },
            sublevelRules: {
                categoryName: [
                    {
                        required: true,
                        message: "请填写子级名称",
                        trigger: "blur"
                    }
                ]
            },
            props: {
                value: 'id',//设置每个menu的ID值
                label: 'categoryName',//设置每个menu的name值
                children: 'children',//子级
            },
        }
    },
    created() {
        this.str = JSON.parse(localStorage.getItem('role'))
		this.companyId = this.str.company_id
        this.getTreedata()
        this.getShopifyProduct()
    },
    methods: {
        searchReset() {
            this.highlight = false
            this.isNullCategory = false
            this.search = ''
            this.currentPage = 1
            this.size = 10
            this.getShopifyProduct()
        },
		Search() {
            this.getShopifyProduct()
		},
        getShopifyProduct(categoryId) {
            const API = Baseurl + 'shopifyProduct/find'
            const paramsData = {
                roleId: this.str.rid,
                page: this.currentPage,
                size: this.size,
                title: this.search,
                isNullCategory: this.isNullCategory,
                categoryId
            }
            ajaxPost(API,paramsData)
                .then((res) => {
                    if(res.data.code === 1) {
                        this.summarylist = res.data.data.records
                        this.summarylist.forEach(val => {
                            const source = val.sourceUrl.split(',')
                            val.productImages = val.productImages.split(',')
                            val.sourceUrl = source.map((item) => ({
                                url: item
                            }))
                        })
                        this.count = res.data.data.total
                    }else {
                        this.$message.error(res.data.message)
                    }
                })
        },
        cascaderChange(event, isLast = false) {
            let obj = ''
            const value = event[event.length - 1]
            this.Treedata.forEach(item => {
                if(item.children) {
                    item.children.forEach(val => {
                        if(val.children) {
                            val.children.forEach(key => {
                                if(item.id == value) {
                                    obj = item
                                    this.selectNodeValue = item.categoryName
                                }else if(val.id == value) {
                                    obj = val
                                    this.selectNodeValue = item.categoryName + ' / ' + val.categoryName
                                }else if(key.id == value){
                                    obj = key
                                    this.selectNodeValue = item.categoryName + ' / ' + val.categoryName + ' / ' + key.categoryName
                                }
                            })
                        }else{
                            if(val.id == value) {
                                obj = val
                                this.selectNodeValue = item.categoryName + ' / ' + val.categoryName
                            }
                        }
                    })
                }else{
                    if(item.id == value) {
                        obj = item
                        this.selectNodeValue = item.categoryName
                    }
                }
            })
            this.categoryId = obj.id
            this.isLastChildNode = false
            if(isLast) {
                this.isLastChildNode = true
            }
        },
        mouseover(data) {
            if(data.menuType == 0) {
                this.$set(data, 'plus', true)
                this.$set(data, 'minus', false)
                this.$set(data, 'edit', false)
            }else if(data.menuType == 3) {
                this.$set(data, 'plus', false)
                this.$set(data, 'minus', true)
                this.$set(data, 'edit', true)
            }else if(data.menuType == 1 || data.menuType == 2)  {
                this.$set(data, 'plus', true)
                this.$set(data, 'minus', true)
                this.$set(data, 'edit', true)
            }
            // this.$set(data, 'minus', true)
            // this.$set(data, 'edit', true)
            // if(data.menuType == 2) {
            //     this.$set(data, 'plus', false)
            // }else {
            //     this.$set(data, 'plus', true)
            // }
        },
        mouseleave(data) {
            this.$set(data, 'plus', false)
            this.$set(data, 'minus', false)
            this.$set(data, 'edit', false)
        },  
        sublevelSubmit(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    if (this.isEdit) {
                        const API = Baseurl + 'systemCategory/update'
                        const paramsData = {
                            id: this.sublevelForm.id,
                            parentId: this.sublevelForm.parentId,
                            categoryName: this.sublevelForm.categoryName,
                            companyId: this.companyId
                        }
                        ajaxPost(API,paramsData)
                            .then((res) => {
                                if( res.data.code === 1 ) {
                                    this.$message({
                                        type: "success",
                                        message: "编辑成功!"
                                    });
                                    this.sublevelVisible = false
                                    this.getTreedata()
                                } else {
                                    this.$message.error(res.data.message)
                                }
                            })
                    }else{
                        const API = Baseurl + 'systemCategory/create'
                        const paramsData = {
                            parentId: this.sublevelForm.id,
                            categoryName: this.sublevelForm.categoryName,
                            companyId: this.companyId
                        }
                        ajaxPost(API,paramsData)
                            .then((res) => {
                                if( res.data.code === 1 ) {
                                    this.$message({
                                        type: "success",
                                        message: "添加成功!"
                                    });
                                    this.sublevelVisible = false
                                    this.getTreedata()
                                } else {
                                    this.$message.error(res.data.message)
                                }
                            })
                    }
                }else{
                    this.$message.error("请填写必填项");
                    return false;
                }
            })
        },
        allowDrop(draggingNode, dropNode, type) {
            //pid是父节点id
            if (draggingNode.data.parentId === dropNode.data.parentId) {
                return type === "prev" || type === "next";
            } else {
                // 不同级进行处理
                return false;
            }
        },
        sort(draggingNode, dropNode, type, event) {
            let obj = {
                params: []
            }
            for(let item of dropNode.parent.childNodes) {
                obj.params.push(item.data);
            }
            this.updateOrderMe(obj)
        },
        updateOrderMe(params) {
            const API = Baseurl + 'systemCategory/updateSort'
            ajaxPost(API,params)
                .then((res) => {
                    if( res.data.code === 1 ) {
                        // this.getTreedata()
                        this.$message.success("修改成功");
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
        },
        getTreedata() {
            const API = Baseurl + 'systemCategory/find?companyId='+this.str.company.id
            ajaxGet(API)
                .then((res)=> {
                    if( res.data.code === 1 ) {
                        this.$set(this.Treedata, 0, { categoryName: '分类列表',children:[],menuType: 0 })
                        res.data.data.forEach(item => {
                            this.$set(item, 'menuType', 1)
                            if(item.children) {
                                item.children.forEach(val => {
                                    this.$set(val, 'menuType', 2)
                                    if(val.children) {
                                        val.children.forEach(key => {
                                            this.$set(key, 'menuType', 3)
                                        })
                                    }
                                })
                            }
                        })
                        this.Treedata[0].children = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
        },
        submitOuterForm() {
            const API = Baseurl + 'shopifyProduct/updateProductCategory'
            const paramsData = {
                categoryId: this.categoryId,
                productIds: this.batch_select
            }
            ajaxPost(API,paramsData)
                .then((res) => {
                    if(res.data.code === 1) {
                        this.$message({
                            type: 'success',
                            message: '移动成功!'
                        });
                        this.dialogVisible = false
                    }else{
                        this.$message.error(res.data.message)
                    }
                })
        },
		handleCurrentChange(val) {
			this.currentPage = val
            this.getShopifyProduct()
		},
		handleSizeChange(val) {
			this.size = val
            this.getShopifyProduct()
		},
        append(data) {
            this.isEdit = false;
            this.sublevelVisible = true
            if(data) {
                this.sublevelForm = {
                    parentName: data.categoryName,
                    categoryName: "",
                    id: data.id,
                    parentId: data.parentId
                }
            } else {
                this.sublevelForm = {
                    parentName: 0,
                    categoryName: "",
                    id: "",
                    parentId: ""
                }
            }
        },
        remove(node, data) {
            this.$confirm("此操作将永久删除该分类, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
              .then(() => {
                const API = Baseurl + 'systemCategory/delete/' + data.id
                ajaxGet(API)
                    .then((res) => {
                        if( res.data.code === 1 ) {
                            this.$message({
                                type: "success",
                                message: "删除成功!"
                            });
                            this.getTreedata()
                        } else {
                            this.$message.error(res.data.message)
                        }
                    })
              })
              .catch(() => {
                this.$message({
                    type: "info",
                    message: "已取消删除"
                });
              });
        },
        editSublevel(data, node) {
            this.isEdit = true;
            this.sublevelVisible = true
            this.sublevelForm.categoryName = data.categoryName
            this.sublevelForm.id = data.id
            this.sublevelForm.parentName = node.parent.data.categoryName
            this.sublevelForm.parentId = data.parentId
        },
        handleNodeClick(val) {
            this.highlight = true
            this.getShopifyProduct(val.id)
        },
        on_batch_select(val) {
            var newarr = [];
            this.piece = val.length;
            for (var i = 0; i < val.length; i++) {
                newarr.push(val[i].id);
            }
            this.batch_select = newarr;
            this.batch_select2 = val;
        },
        edit(type, row) {
            if (type === 'all' && this.piece == 0) {
                this.$message.warning('请至少勾选一件产品！')
                return;
            } else if(type === 'single'){
                var newarr = []
                newarr.push(row.id)
                this.batch_select = newarr
                this.dialogVisible = true
            }else{
                this.dialogVisible = true
            }
        }
    }
}
</script>
<style lang="scss" scoped>
/deep/ .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
    background-color: #ccc !important;
}
/deep/ .el-tree-node__content:hover {
  background: #eee !important;
}
.Classification{
    width: 98%;
    display: flex;
    justify-content: space-between;
    padding-bottom: 100px;
    .left {
        width: 15%;
        border-radius: 4px;
        float: left;
        border: 1px solid #eee;
        padding: 10px 0;
        .custom-tree-node {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 14px;
            padding-right: 8px;
            .el-icon-minus {
                margin: 0 8px;
            }
        }
    }
    .right {
        width: 84%;
    }
    .summary_pagenum {
        width: 98.5%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        overflow: hidden;
        background: #f5f5f5;
        line-height: 40px;
        padding: 0 10px;
        .block {
            .el-input {
                width: 400px;
                margin-right: 10px;
            }
        }
    }
    .summary_pagenum_block {
        width: 1789px;
        padding: 20px;
        position: fixed;
        right: 0;
        bottom: 0;
        background: #fff;
        z-index: 999;
        .el-pagination {
            display: flex;
            justify-content: center;
        }
    }
	// 级联面板
	.el-cascader-panel.custom-cascader {
		overflow: auto;
		.el-cascader-menu__wrap {
			height: 400px;
		}
	}
	.selectNodeValue {
		min-height: 30px;
		display: flex;
		align-items: center;
		padding-bottom: 10px;
	}
}
</style>